.dialog {
	outline: none;
}
